import { EntityActionReducerBuilderInterface, REQUEST_STATE } from "../../dataTypes";
import { fetchFiles } from "../../pageContent/reducers/fetchFiles";
import { File } from "../dataTypes";
import { fileAdapter } from "../fileAdapter";

export const addFetchFilesForPageContentReducers = (builder: EntityActionReducerBuilderInterface<File>) => {
  builder.addCase(fetchFiles.fulfilled, (state, action) => {
    const { payload } = action;

    fileAdapter.upsertMany(
      state,
      payload.page.map(responseObject => ({
        ...responseObject,
        fetchedTimestamp: Date.now(),
        requestStatus: REQUEST_STATE.FULFILLED,
        errorMessage: undefined,
      })),
    );
  });
};
